import { Stack } from "@mui/material";
import React from "react";
import { cn } from "utils/styling";

export const LabelValueInline = ({ className, label, labelProps, value, valueProps }) => {
  const { className: valueClassName, ...otherValueProps } = valueProps;
  const { className: labelClassName, ...otherLabelProps } = labelProps;
  return (
    <Stack className={cn("mb-1 items-start font-ds-body-regular-xs", className)}>
      <div
        className={`min-w-[12rem] max-w-[33rem] !text-lds-foreground-muted-subtle font-ds-body-semibold-md ${labelClassName}`}
        {...otherLabelProps}
      >
        {label}:
      </div>
      <div className={`ml-1 font-ds-body-regular-md  ${valueClassName}`} {...otherValueProps}>
        {` ${value}`}
      </div>
    </Stack>
  );
};
